const UPDATE_BBOX = 'tuko-kartta/bbox/UPDATE_BBOX';

export default function bbox(state = { bbox: [] }, action) {
  switch (action.type) {
    case UPDATE_BBOX:
      return Object.assign({}, state, { bbox: [
        action.bbox.left,
        action.bbox.bottom,
        action.bbox.right,
        action.bbox.top
      ] });
    default:
      return state;
  }
}

export function updateBbox(box) {
  return { type: UPDATE_BBOX, bbox: box };
}



// WEBPACK FOOTER //
// ./src/reducers/bbox.js